import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { handleHtmlClick } from '../utils/ktcUtils';
import { Modal as BsModal } from 'bootstrap';
import { API_URL } from '../constants/api';
import ModalForm from './ModalForm';
import { decodeToken, getToken } from '../utils/TokenUtils';
export default function Table({ 
  tbodyData
}) {

  const theadData = tbodyData?.length ? Object.keys(tbodyData[0]) : [];
  const [currentRoute, setCurrentRoute] = useState('');
  const [queryParams, setQueryParms] = useState('');
  const [updateId, setUpdateId] = useState(null);
  const [isModalFormOpen, setIsModalFormOpen] = useState(false);

  const token = getToken();
  const userId = decodeToken(token, "id");

  const isImage = (t) =>
    t.toLowerCase().endsWith('.jpg') ||
    t.toLowerCase().endsWith('.png') ||
    t.toLowerCase().endsWith('.jpeg') ||
    t.toLowerCase().endsWith('.gif') ||
    t.toLowerCase().endsWith('.webp') ||
    t.toLowerCase().endsWith('.jfif');

  function openGallery(images, startIndex = 0) {
      const container = document.getElementById('carousel-inner-container');
      container.innerHTML = '';
  
      images.forEach((img, i) => {
        const active = i === startIndex ? 'active' : '';
        const encoded = encodeURI(img);
  
        container.innerHTML += `
        <div class="carousel-item ${active} h-100">
          <img src="${API_URL}/${encoded}" class="gallery-img" />
        </div>
      `;
      });
  
      const modalElement = document.getElementById('galleryModal');
      const modal = BsModal.getOrCreateInstance(modalElement);
      modal.show();
    }  
  
  
    const openFormModal = (route, queryParams) => {
      // console.log('queryParams:', queryParams);
      setCurrentRoute(route);
      setQueryParms(queryParams);
      // setUpdateTable()
      setIsModalFormOpen(true);
    };

    const closeFormModal = () => {
      setUpdateId(null);
      setIsModalFormOpen(false);
    };  
   
  
  const renderCellContent = (text, key) => {
    if (typeof text !== 'string') return text;

    // Regex to extract href, class, and inner text
    const anchorRegex = /^<a[^>]+href="([^"]+)"[^>]*className="([^"]+)"[^>]*>([^<]+)<\/a>$/;
    const match = text.match(anchorRegex);

    const regex0 = /<a\s+href="([^"]+)"\s+className="([^"]+)"\s+title="([^"]+)">([^<]+)<\/a>/;
    const match0 = text.match(regex0);

    // Check only if it's an anchor
    const anchorRegex2 = /<a[^>]+href="([^"]+)"[^>]*>([^<]+)<\/a>/;
    const match2 = text.match(anchorRegex2);

    if (match || match0) {
      let href = '';
      let className = '';
      let displayText = '';
      let title = '';

      if (match) {
        href = match[1];
        className = match[2];
        displayText = match[3];
      }

      if (match0) {
        href = match0[1];
        className = match0[2];
        displayText = match0[4];
        title = match0[3];
      }


      if (href.startsWith('form-modal?')) {
        const parts = href.split('?');
        const route = parts[1];
        const queryParms = parts.slice(2).join('?');

        return (
          <button
            className={`btn ${className}`}
            onClick={() => openFormModal(route, queryParms)}
            key={key}
          >
            {displayText}
          </button>
        );
      }

      return (
        <a
          href={href}
          className={`btn ${className}`}
          target="_blank"
          rel="noopener noreferrer"
          key={key}
        >
          {displayText}
        </a>
      );
    }

    if (match2) {
      const href = match2[1];
      const linkText = match2[2];

      const shouldOpenInNewTab =
        href.startsWith('/invoice') ||
        href.startsWith('/pos-invoice') ||
        href.startsWith('/qrcode') ||
        href.startsWith('/sales-invoice') ||
        href.includes('wa.me');

      if (shouldOpenInNewTab) {
        return (
          <a href={href} target="_blank" rel="noopener noreferrer" key={key}>
            {linkText}
          </a>
        );
      } else {
        return <Link to={href} key={key}>{linkText}</Link>;
      }
    }

    // MULTI IMAGES
    if (isImage(text) && text.includes(',')) {
      const arr = text.split(',').map((t) => t.trim());
      return (
        <div className="d-flex gap-2" key={key}>
          {arr.map((img, i) => {
            const encoded = encodeURI(img);
            return (
              <img
                key={i}
                src={`${API_URL}/${encoded}`}
                alt="gallery item"
                style={{ width: 50, height: 50, objectFit: 'cover', cursor: 'pointer' }}
                onClick={() => openGallery(arr, i)}
              />
            );
          })}
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => openGallery(arr, 0)}
          >
            View All
          </button>
        </div>
      );
    }

    // SINGLE IMAGE
    if (isImage(text)) {
      const encodedPath = encodeURI(text);
      return (
        <img
          src={text.includes('http') ? text : `${API_URL}/${encodedPath}`}
          alt="Image Not Found"
          key={key}
          style={{ width: 50, height: 50, objectFit: 'cover', cursor: 'pointer' }}
          onClick={() => openGallery([text], 0)}
        />
      );
    }

    // DOCUMENTS / FILES
    if (
      text.endsWith('.pdf') ||
      text.endsWith('.doc') ||
      text.endsWith('.docx') ||
      text.endsWith('.xlsx') ||
      text.endsWith('.xls') ||
      text.endsWith('.ppt') ||
      text.endsWith('.pptx') ||
      text.endsWith('.csv') ||
      text.endsWith('.txt') ||
      text.endsWith('.mp4') ||
      text.endsWith('.mov') ||
      text.endsWith('.wmv') ||
      text.endsWith('.avi')
    ) {
      return (
        <a
          href={`${API_URL}/${text}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#007bff', textDecoration: 'underline' }}
          key={key}
        >
          Preview or Download
        </a>
      );
    }

    // GENERAL HTML FALLBACK
    if (text.includes('<') && text.includes('>')) {
      return (
        <span
          key={key}
          dangerouslySetInnerHTML={{ __html: text }}
          onClick={handleHtmlClick}
        />
      );
    }

    return text;
  };

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped table-hover align-middle">
        <thead className="table-dark">
          <tr>
            {theadData.map((heading) => (
              <th key={heading}>{heading}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {tbodyData?.length ? (
            tbodyData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {theadData.map((key) => (
                  <td key={key}>
                    {renderCellContent(row[key], key)}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={theadData.length} className="text-center text-muted">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {isModalFormOpen && currentRoute && (
              <ModalForm
                userId={userId}
                token={token}
                queryParams={queryParams}
                route={currentRoute} // Pass the dynamic route to the modal
                isOpen={isModalFormOpen}
                onRequestClose={closeFormModal}
              />
            )}
    </div>
  );
}